import { propsFactory } from '@components/utils';

import type { IGridProps } from '../types';
import type { PropType } from 'vue';

export interface ISubgridProps extends IGridProps {
  subgrid: boolean;
}
export interface IUseSubgrid {
  suffix: string;
}

export const makeSubgridProps = propsFactory(
  {
    /**
     * Only CSS Grid supported. Вложенная сетка
     */
    subgrid: {
      type: Boolean as PropType<boolean>,
      default: false
    }
  },
  'subgrid'
);

export const useSubgrid = (props: ISubgridProps): IUseSubgrid => {
  const suffix = props.subgrid ? 'subgrid' : 'css-grid';

  return {
    suffix
  };
};
